<template>
  <div id="app">
    <Header />
    <div class="content">
      <div class="main">
        <router-view/>
      </div>
      <div class="sidebar">
        <div class="box-banner">
          <img src="@/assets/banner/n1.png" class="banner">
        </div>
        <div class="box-banner">
          <img src="@/assets/banner/n2.png" class="banner">
        </div>
        <div class="box-banner">
          <img src="@/assets/banner/n3.png" class="banner">
        </div>
        <div class="box-banner">
          <img src="@/assets/banner/n4.png" class="banner">
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from '@/views/components/Header'
import Footer from '@/views/components/Footer'

export default {
  components: {
    Header,
    Footer
  }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

/* Import Font Awesome 5 Icons Set */
$fa-font-path: '~@fortawesome/fontawesome-free/webfonts';
@import '~@fortawesome/fontawesome-free/scss/fontawesome.scss';
@import '~@fortawesome/fontawesome-free/scss/solid.scss';
@import '~@fortawesome/fontawesome-free/scss/regular.scss';
@import '~@fortawesome/fontawesome-free/scss/brands.scss';

body {
  font-family: Montserrat,Helvetica,Arial,sans-serif;
  font-weight: 400;
  background: #fff url('assets/theme/bg.png') repeat-x left 0;
}

.clearfix {
  clear: both;
}

#app {
  width: 1000px;
  max-width: 100%;
  margin: 0 auto;
  background-color: #FFF;
  padding-bottom: 0px;

  .content {
    padding: 0px 5px;
    margin: 0px;

    .main {
      float: left;
      width: 670px;
      margin: 10px 5px;
    }

    .sidebar {
      float: left;
      width: 300px;
      max-width: 100%;
      margin: 10px 5px;

      .box-banner {
        margin-bottom: 5px;
        text-align: center;

        .banner {
          width: 300px;
          max-width: 100%;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  #app {
    width: 100%;

    .content {
      margin-top: 5px;

      .main {
        float: none;
        width: 100%;
        margin: 0;
      }

      .sidebar {
        float: none;
        width: 100%;
        margin: 20px 0;

        .box-banner {
          margin-bottom: 5px;
          text-align: center;

          .banner {
            width: 100%;
            max-width: 300px;
          }
        }
      }
    }
  }

  #footer {
    margin-top: 0px;
  }
}
</style>
